import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import blogs from "../data/blogdata";

// const blogs = [
//   {
//     id: 1,
//     title: "HALO Explained",
//     description: "Learn about HALO: actionable insights with minimal observation.",
//     image: "/blog-image3.svg",
//   },
//   {
//     id: 2,
//     title: "The Future with OpenAI",
//     description: "Discover how AI is empowering people across the world—today.",
//     image: "/Open_Ai.jpg",
//   },
//   {
//     id: 3,
//     title: "How to build a website",
//     description: "Building a website involves several steps, from planning and design to development and deployment.",
//     image: "/blog-image3.svg",
//   },
//   {
//     id: 4,
//     title: "Fourth Blog Title",
//     description: "This is the short description for the fourth blog.",
//     image: "https://picsum.photos/id/1014/600/400",
//   },
//   // Add more blogs as needed
// ];

export default function BlogListPage() {
  const [showAll, setShowAll] = useState(false);
   const navigate = useNavigate()

  const displayedBlogs = showAll ? blogs : blogs.slice(0, 3);

  return (
    <div className="blog-container">
      <div className="blog-main"> 
        <p className="best-post-content-sub">
          Blog & News
        </p>
        <h1 className="best-post-content-title">Explore Our Latest Industry Insights</h1>
          <hr className="portfolio-horizontalline"></hr>
      </div>

      <div className="row blog-cards">
        {displayedBlogs.map((blog) => (
          <div key={blog.id} className="post__card-2">
            <div className="post__card_-2">
              <div
                className="post__card__image-2"
                style={{ backgroundImage: `url(${blog.image})` }}
                alt={blog.title}
              />
              <div className="post__card_meta-2">
                <div className="post__card_cat">{blog.category}</div>
                <h3 className="post__card_title-2">{blog.title}</h3>
                <p className="post__card_alttitle-2">{blog.description}</p>
                <Link to={`/blog/${blog.id}`} className="readmore-btn">
                  Read More<span> →</span>
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
{/* 
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <button className="btn-showorless" onClick={() => setShowAll(!showAll)}>
          {showAll ? "Show Less" : "Show More"}
        </button>
      </div> */}
   <div className={`flip-toggle ${showAll ? "active" : ""}`} onClick={() => navigate('/Blog')}>
        <div className="flip-inner">
            <div className="flip-front">Show More</div>
            {/* <div className="flip-back">Show Less</div> */}
        </div>
    </div>

    </div>
  );
}
